import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../hooks/useAuth";
import { continuarConPlanPendiente } from "../lib/planPendiente";

export default function GoogleAuthSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { saveSession } = useAuth();
  const [error, setError] = useState(false);

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setError(true);
      return;
    }
    const esNuevo = searchParams.get("nuevo") === "1";
    api.me(token).then(async (r) => {
      if (!r.ok) {
        setError(true);
        return;
      }
      saveSession(token, r.data.user);

      if (esNuevo) {
        navigate("/completar-perfil", { replace: true });
        return;
      }

      const fueAStripe = await continuarConPlanPendiente(token);
      if (!fueAStripe) navigate("/dashboard", { replace: true });
    });
  }, [searchParams]);

  if (error) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--bg)", fontFamily: "var(--font-body)", padding: 24 }}>
        <div className="card" style={{ maxWidth: 380, width: "100%", padding: 32, textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>⚠️</div>
          <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 19, margin: "0 0 10px" }}>
            No pudimos iniciar sesión con Google
          </h1>
          <p style={{ fontSize: 14, color: "var(--muted)", marginBottom: 20 }}>
            Intenta de nuevo o usa tu correo y contraseña.
          </p>
          <Link to="/login" className="btn btn-primary btn--full">Volver a iniciar sesión</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--bg)" }}>
      <span className="spinner spinner--dark" />
    </div>
  );
}
